<template>
  <v-container fluid class="dashboard-page mt-3">
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="8" class="d-sm-flex justify-md-start justify-space-between align-center">
                <h1 class="main-page-title greyMedium--text mb-0 mr-2 pt-4 pt-md-0">ChatXC</h1>
                <v-text-field
                    v-model="chatMessage"
                    v-on:keyup.enter="newMessage"
                    single-line
                    hide-details
                    class="mb-4"
                    label="Type a message"
                  ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="d-sm-flex justify-md-start justify-space-between align-center">
                <v-select
                    class="mb-4"
                    :items=chatChannels
                    v-model="channel"
                    v-on:change="changeChatChannel"
                    hide-details
                    single-line hint="Please choose the pay method type"
                  >
                  </v-select>
              </v-col>
              <v-col cols="12" md="1" class="d-sm-flex justify-md-start justify-space-between align-center">
                  <v-btn
                    block
                    color="primary"
                    class="elevation-0 text-capitalize"
                    @click="newMessage"
                  >
                    Send
                  </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters class="d-flex align-center mt-8 mb-3 px-5 py-1 mx-1">
              <v-col cols="12"  v-for="(item, i) in chats" :key="i">
                <v-list two-line>
                  <v-list-item
                      style="min-height: 10px;"
                      class="px-0"
                    >
                      <v-list-item-avatar class="my-0 text-right align-self-start" style="width: 50px; height: 50px;">
                        <v-img :src="item.chatimage"></v-img>
                      </v-list-item-avatar>
      
                      <v-list-item-content class="py-0" style="vertical-align: text-top;">
                        <v-list-item-title class="font-weight-bold greyBold--text" v-html="item.chatname"></v-list-item-title>
                        <v-list-item-subtitle class="greyBold--text fs-base text-wrap" v-html="item.chattext.replace('\n', '<br>')"></v-list-item-subtitle>
                      </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-col v-if="item.chatdata!=null && item.chatdata.length>0" cols="12" md="2" class="d-sm-flex justify-md-start justify-space-between align-center">
                  <download-excel
                    
                    class="btn btn-default"
                    :data="item.chatdata"
                    worksheet="My Worksheet"
                    type="xls"
                    :name="getFileName()"
                  >
                  <v-btn
                    
                    plain
                    size="x-small"
                    color="primary"
                  >
                    <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                    Save
                  </v-btn>
                </download-excel>
              </v-col>
                <v-data-table
                    v-if="item.chattype=='assistant' && item.chatdata!=null"
                    :headers="getHeaders(item.chatdata)"
                    :items="getFormatted(item.chatdata)"
                >
                </v-data-table>
                <div v-if="item.chatquery!=null  && item.chatquery!=''" style="font-size: small; margin-bottom: 5px;">Query: {{ item.chatquery}}</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'Dashboard',
    data() {
      return {
        menu: false,
        chatMessage: '',
        channel: null,
      };
    },
    computed: {
      ...mapState('Chat', ['chats', 'chatChannel', 'chatChannels'])
    },
    async created () {
      this.initChatChannel();
      this.channel = this.chatChannel;
      if(this.chats==null || this.chats.length==0) await this.getChatsRequest();
      if(this.chats.length==0) this.greet();
      else if(this.chats[0].chattype!=='greeting') this.greet();
    },
    methods: {
      ...mapActions('Chat', [
        "getChatsRequest", "setChatChannel", "initChatChannel", "popChatsFirst",
        "getSalesGreetingRequest", "getSalesQueryRequest",
        "getPurchaseGreetingRequest", "getPurchaseQueryRequest",
      ]),
      newMessage: function () {
        this.chatMessage = this.chatMessage.trim();
        if (this.chatMessage.length !== 0) this.send({prompttext: this.chatMessage});
        this.chatMessage = '';
      },
      changeChatChannel(value){
        console.log(value)
        this.setChatChannel({channel: value});
        this.channel = value;
        this.greet();
      },
      greet(){
        if(this.chats.length>0 && this.chats[0].chattype==['greeting'] && this.chats[0].chatname==this.channel) return;
        if(this.chatChannel=='Sales Data Assistant') this.getSalesGreetingRequest();
        else if(this.chatChannel=='Purchase Data Assistant') this.getPurchaseGreetingRequest();
      },
      send(payload){
        if(this.chatChannel=='Sales Data Assistant') this.getSalesQueryRequest(payload);
        else if(this.chatChannel=='Purchase Data Assistant') this.getPurchaseQueryRequest(payload);
      },
      formatNumber(value){
        if (typeof(value) === "number") return value.toLocaleString("en-SG");
        else return value;
      },
      getFileName(){
        var d = new Date();
        var name = 'sales-data-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
        return name + '.xls';
      },
      getHeaders(list){
        if(list==null || list.length==0) return [];
        let obj = list[0];
        let keys = Object.keys(obj);
        return keys.map(key=>{return {text: key, value: key}})
      },
      getKeys(list){
        let obj = list[0];
        let keys = Object.keys(obj);
        return keys
      },
      getFormatted(list){
        if(list==null || list.length==0) return [];
        let results = []
        for(var index in list){
          let item = Object.assign({},list[index])
          let keys = Object.keys(item);
          for(var i in keys){
            let key = keys[i];
            item[key] = this.formatNumber(item[key]);
          }
          results.push(item);
        }
        return results;
      },
    },
  };
</script>

<style src="./ChatXC.scss" lang="scss"/>
